import apiService from "./apiService"; // your custom axios instance
const CATERING_ITEMS_API_URL = "/catering-items";

/**
 * Get all catering master items
 * @returns {Promise<Array>}
 */
export const getCateringItems = async () => {
  try {
    const response = await apiService.get(CATERING_ITEMS_API_URL);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to fetch catering items" };
  }
};
 
/**
 * Create a new master catering item (admin only)
 * @param {Object} itemData
 * @returns {Promise<Object>}
 */
export const createCateringItem = async (itemData) => {
  try {
    const response = await apiService.post(CATERING_ITEMS_API_URL, itemData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to create item" };
  }
};
